export const responsiveTable = (context = document) => {
  const tables = context.querySelectorAll('.layout-container table');
  if (!tables) return;

  const getLabels = table => {
    const labels = [];
    const cells = table.querySelectorAll('thead th');
    cells.forEach(cell => labels.push(cell.innerText));
    return labels;
  };

  const applyLabels = table => {
    const labels = getLabels(table);
    const cells = table.querySelectorAll('tbody td');
    cells.forEach(cell => {
      const parent = cell.parentNode;
      const index = Array.prototype.indexOf.call(parent.children, cell);
      if (labels[index]) {
        cell.setAttribute('data-label', labels[index]);
      }
    });
  };

  [...tables].forEach(table => {
    applyLabels(table);
  });
};
